import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtGenLookupComponent } from '../../ct-gen-lookup/ct-gen-lookup.component';
import { DxButtonModule, DxDropDownBoxModule, DxListModule, DxLoadPanelModule, DxPopupModule, DxTreeListModule, DxTreeViewModule } from 'devextreme-angular';
import { CtlBirimTurTreeService } from './ctl-birim-tur-tree.service';
import { GenBirim } from 'libs/gen/src/lib/models/gen.models';
import { UtilsService } from '../../../services/utils.service';
import { DxoPagingModule } from 'devextreme-angular/ui/nested';
import {DxDropDownBoxTypes} from "devextreme-angular/ui/drop-down-box";
import { BysGeticbirimlerliste_CursorDto } from 'libs/bys/src/lib/models/bys-cursors.models';

@Component({
  selector: 'dk-ctl-birim-tur-tree',
  standalone: true,
  imports: [CommonModule,CtGenLookupComponent,DxDropDownBoxModule,DxTreeViewModule,DxLoadPanelModule,DxoPagingModule,
    DxTreeListModule,DxButtonModule,DxPopupModule,DxListModule],
  templateUrl: './ctl-birim-tur-tree.component.html',
  styleUrls: ['./ctl-birim-tur-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtlBirimTurTreeComponent implements OnInit{
  public dataSource: any;
  public birimTuru: string;
  public selectedBirim = new GenBirim({});
  public isTreeBoxOpened = false;
  public isCheckBirimTur = true;
  public isLoading = false;
  isIcBirimlerDagitOpen=false;
  isShowBtn=false;
  @Input() belgeKod:number;
  @Output() dataResult = new EventEmitter<GenBirim>();
  @Output() bilgiBirimResult = new EventEmitter<any>();
  @Output() geregiBirimResult = new EventEmitter<any>();
  treeBoxValue:any= []
  icBirimlerList:BysGeticbirimlerliste_CursorDto[];
  public selectedArray:any[] = [];

  constructor(private service: CtlBirimTurTreeService, private utilService: UtilsService,
              private ref: ChangeDetectorRef){
              }

  ngOnInit(): void {
    if(this.belgeKod) this.getIcBirimler();
  }

  valueChangeBirimTur(e:any){
    if(e.value === "I") this.isShowBtn = true;
    else  this.isShowBtn = false;
    this.isLoading = true;
    //this.isTreeBoxOpened = true;
    this.birimTuru = e.value;
    this.selectedBirim = new GenBirim({});
    this.dataSource = this.service.getDataSource(this.birimTuru);
    this.isCheckBirimTur = false;
  }

  selectedRowData(e:any){
    this.selectedBirim = e;
    this.isTreeBoxOpened = false;
    this.dataResult.emit(this.selectedBirim)
  }

  onTreeBoxOptionChanged(e: DxDropDownBoxTypes.OptionChangedEvent) {
    if (e.name === 'value') {
      this.isTreeBoxOpened = false;
      this.ref.detectChanges();
    }
  }

  openList(){

    this.isIcBirimlerDagitOpen=true;
  }

  getIcBirimler(){
    this.service.getIcBirimlerList(this.belgeKod).subscribe({
      next:(res)=>{
        this.icBirimlerList=res.value;
      },
      error:()=>{
        this.utilService.showError('Ic Birimler Alinamadi');
      }
    })
  }

  selectionBirimList(e:any){
    if(e.addedItems.length > 0){
      e.addedItems.forEach((item:any) => {
        this.selectedArray.push(item)
      })
    }
    if(e.removedItems.length > 0){
      e.removedItems.forEach((removeItem:any) => {
        this.selectedArray = this.selectedArray.filter(item => item.BirimKodu !== removeItem.BirimKodu);
      })
    }
  }

  bilgiBirimKaydet(){
    this.bilgiBirimResult.emit(this.selectedArray)
  }


  geregiBirimKaydet(){
    this.geregiBirimResult.emit(this.selectedArray)
  }

}
